<template>
  <div class="page-wrapper">
    <div class="page-section">
      <div class="cg-crumb">
        <btn-back />
        <span class="item">订单管理</span>
        <em class="gap">/</em>
        <span class="item">清算详情</span>
      </div>
      <div class="cg-main-title">清算详情</div>
      <div class="header-handle-box">
        <h3 class="state">
            清算订单号：{{lDetail.order_number}}
            <span class="status">{{lDetail.order_state == 2 ? '已发起清算' : ''}}</span>
            <span class="status">{{lDetail.order_state == 5 ? '退货数量审核中' : ''}}</span>
            <span class="status">{{lDetail.order_state == 4 ? '退货数量审核被拒绝' : ''}}</span>
            <span class="status">{{lDetail.order_state == 3 ? '退货数量审核通过，进入清算付款阶段' : ''}}</span>
            <span class="status">{{lDetail.order_state == 6 ? '清算已完成' : ''}}</span>
        </h3>
        <div class="btns">
          <button class="cg-btn red" @click="startLiquidation" v-if="!lDetail.order_state">发起清算</button>
          <button
            class="cg-btn red-border"
            v-if="lDetail.order_state == 5"
            @click="confirmReturnGoodsPop = true"
          >确认退货数量</button>
          <!-- <button class="cg-btn red-border" v-if="lDetail.order_state == 3">确认付款凭证</button> -->
        </div>
      </div>
      <div class="basic-wrap clearfix">
        <div class="img-wrap">
          <el-image
            class="img"
            :src="lDetail.productMainImageFile"
            fit="cover"
            :preview-src-list="[lDetail.productMainImageFile]"
          ></el-image>
        </div>
        <div class="basic-info">
          <el-row>
            <div class="line">
              <span class="lab">商品名称：</span>
              <span class="val tit">{{lDetail.item_name}}</span>
            </div>
            <div class="line">
              <span class="lab">商品款号：</span>
              <span class="val tit">{{lDetail.item_style_number}}</span>
            </div>
            <div class="line">
              <span class="lab">供应商：</span>
              <span class="val tit">{{lDetail.supplierName}}</span>
            </div>
            <div class="line">
              <span class="lab">销售商：</span>
              <span class="val tit">{{lDetail.dealerName}}</span>
            </div>
            <div class="line">
              <span class="lab">当前定价：</span>
              <span class="val tit">{{lDetail.item_order_price | tablePrice}} 元</span>
            </div>
          </el-row>
        </div>
      </div>
    </div>

    <div class="page-section" v-if="lDetail.order_state == 3 || lDetail.order_state == 6">
      <div class="cg-mod-title mgt-0">清算数据</div>
      <div class="basic-info mgt-24">
        <el-row>
          <!-- <el-col :span="24"><div class="line">
                        <span class="lab">平台需确认销售商支付金额：</span>
                        <span class="lab green"> ? 元</span>
          </div></el-col>-->
          <el-col :span="24">
            <div class="line">
              <span class="lab">销售商需支付总金额：</span>
              <span class="green">
                {{ billList_final.order_arrears_amount }} +
                <!-- {{ billList_final.order_bill_amount }} = -->
                {{billList_final.autoEstablish}} x {{lDetail.item_order_price | tablePrice}} x {{lDetail.supplier_rate}}% =
                {{ billList_final.dealerSumPay }}元
              </span>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="line">
              <span class="val">供应商同意了销售商的{{billList_final.orderRefundQuantity}}件退货请求</span>
              <br />
              <span class="val">
                本次清算，
                {{billList_final.liquidateDataInfo && billList_final.liquidateDataInfo.order_submit_time}}
                销售商发起了退货{{billList_final.orderRefundQuantity}}件，
                退货后自动核销：{{billList_final.autoEstablish}}件
              </span>
              <br />
              <span class="val">退货前您还需提交发起支付金额：{{ billList_final.order_arrears_amount }} 元</span>
              <br />
              <!-- <span class="val">需平台确认支付金额：? 元</span> -->
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="time-line-title" v-if="platform_billList_final.liquidateOrderPaymentList">
        <h4 class="time-line-title-h4">
          平台结款支付
        </h4>
        <div
          class="time-line-title-sub"
        >当前平台已确认金额总计{{platform_billList_final.sum_pay_amonut}}元， 还需支付{{platform_billList_final.chargeBalance}}元</div>
      </div>
      <ul
        class="time-line"
        v-if="platform_billList_final.liquidateOrderPaymentList && platform_billList_final.liquidateOrderPaymentList.length > 0"
      >
        <li
          class="item"
          v-for="(pay_ele, index) in platform_billList_final.liquidateOrderPaymentList"
          :key="index"
        >
          <div class="item-tail"></div>
          <div class="item-node"></div>
          <div class="item-content">
            <div class="pdb-12">
              <span class="title">
                <span class="time">{{pay_ele.order_submit_time}}</span>
                销售商上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
              </span>
              <el-tag type="success" v-if="pay_ele.order_state == 'y'">供应商已确认</el-tag>
              <el-tag type="info" v-if="pay_ele.order_state == 'p'">待供应商确认</el-tag>
              <el-tag type="danger" v-if="pay_ele.order_state == 'n'">供应商已拒绝</el-tag>
              <button
                v-if="pay_ele.order_state == 'p'"
                class="cg-btn red-border mgl-16"
                style="margin-left: 16px"
                @click="getBillPayDetail( pay_ele)"
              >确认结款凭证</button>
            </div>
            <div class="pdb-12">
              <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                <el-image
                  :key="img_index"
                  v-if="img_ele"
                  class="img"
                  :src="img_ele"
                  fit="cover"
                  :preview-src-list="pay_ele.imageFiles"
                ></el-image>
              </template>
              <span
                v-if="pay_ele.order_transfer_memo"
                class="pay-info grey"
              >说明：{{pay_ele.order_transfer_memo}}</span>
            </div>
          </div>
        </li>
      </ul>

      <div
        class="time-line-title"
        v-if="billList_final.liquidateOrderPaymentList && billList_final.liquidateOrderPaymentList.length > 0"
      >
        <h4 class="time-line-title-h4">销售商支付</h4>
        <div
          class="time-line-title-sub"
        >当前平台已确认金额总计{{billList_final.order_pay_amount}}元， 还需支付{{billList_final.chargeBalance}}元</div>
      </div>
      <ul
        class="time-line"
        v-if="billList_final.liquidateOrderPaymentList && billList_final.liquidateOrderPaymentList.length > 0"
      >
        <li
          class="item"
          v-for="(pay_ele, index) in billList_final.liquidateOrderPaymentList"
          :key="index"
        >
          <div class="item-tail"></div>
          <div class="item-node"></div>
          <div class="item-content">
            <div class="pdb-12">
              <span class="title">
                <span class="time">{{pay_ele.order_submit_time}}</span>
                销售商上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
              </span>
              <el-tag type="success" v-if="pay_ele.order_state == 'y'">供应商已确认</el-tag>
              <el-tag type="info" v-if="pay_ele.order_state == 'p'">待供应商确认</el-tag>
              <el-tag type="danger" v-if="pay_ele.order_state == 'n'">供应商已拒绝</el-tag>
            </div>
            <div class="pdb-12">
              <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                <el-image
                  :key="img_index"
                  v-if="img_ele"
                  class="img"
                  :src="img_ele"
                  fit="cover"
                  :preview-src-list="pay_ele.imageFiles"
                ></el-image>
              </template>
              <span
                v-if="pay_ele.order_transfer_memo"
                class="pay-info grey"
              >说明：{{pay_ele.order_transfer_memo}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="page-section" v-if="false">
      <div class="cg-mod-title mgt-0">销售商应付款项</div>
      <ul class="time-line">
        <li class="item" v-for="(item, index) in billList_final" :key="index">
          <div class="item-tail"></div>
          <div class="item-node"></div>
          <div class="item-content">
            <div class="item-tit">销售商付款明细</div>
            <div class="item-box">
              <ul class="sub-time-line">
                <template v-if="item.liquidateOrderPaymentList">
                  <li
                    class="sub-item"
                    v-for="(pay_ele, pay_i) in item.liquidateOrderPaymentList"
                    :key="pay_i"
                  >
                    <div class="pdb-12">
                      <span
                        class="title"
                      >销售商于{{pay_ele.order_submit_time}}上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元</span>
                      <el-tag type="success" v-if="pay_ele.order_state == 'y'">供应商已确认</el-tag>
                      <el-tag type="info" v-if="pay_ele.order_state == 'p'">待供应商确认</el-tag>
                      <el-tag type="danger" v-if="pay_ele.order_state == 'n'">供应商已拒绝</el-tag>

                      <button
                        class="cg-btn red-border mgl-16"
                        v-if="pay_ele.order_state == 'p'"
                        @click="getBillPayDetail(pay_ele)"
                      >确认付款凭证</button>
                    </div>
                    <div class="pdb-12">
                      <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                        <el-image
                          :key="img_index"
                          v-if="img_ele"
                          class="img"
                          :src="img_ele"
                          fit="cover"
                          :preview-src-list="pay_ele.imageFiles"
                        ></el-image>
                      </template>

                      <span
                        v-if="pay_ele.order_transfer_memo"
                        class="pay-info grey"
                      >说明：{{pay_ele.order_transfer_memo}}</span>
                    </div>
                    <!-- <div v-if="pay_ele.order_payment_memo" class="pdb-12 grey">
                                    说明：{{pay_ele.order_payment_memo}}
                    </div>-->
                  </li>
                </template>
                <li class="sub-item">
                  <!-- <div class="pdb-6">
                                       依据平台规则系统于向您发布了以上已核销且销售商已付款的订单明细。
                  </div>-->
                  <div class="grey pdb-12">
                    销售商应向您支付总计
                    <span class="green">{{item.order_bill_amount}}</span>元
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="page-section" v-if="returnGoodsList.length > 0">
      <div class="cg-mod-title mgt-0">操作记录</div>
      <ul class="time-line">
        <li class="item" v-for="(item, index) in returnGoodsList" :key="index">
          <div class="item-tail"></div>
          <div class="item-node"></div>
          <div class="item-content">
            <div class="item-tit">
              <span
                class="title"
              >销售商第{{returnGoodsList.length - index}}次填写退货数量： {{item.return_quantity}} 件</span>
              <el-tag type="success" v-if="item.order_state == 'y'">供应商已确认</el-tag>
              <el-tag type="danger" v-if="item.order_state == 'n'">供应商已拒绝</el-tag>
              <el-tag type="info" v-if="item.order_state == 'p'">待供应商审核</el-tag>
              <button
                class="cg-btn red-border mgl-16"
                v-if="item.order_state == 'p'"
                @click="confirmReturnGoodsPop = true"
              >确认退货数量</button>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="page-section">
      <div class="cg-mod-title mgt-0">清算清单</div>
      <div class="take-order-table clearing">
        <table class="table">
          <tr class="th">
            <th width>下单订单号</th>
            <th width>下单总数</th>
            <th width>
              核销对应
              <br />价格(元)
            </th>
            <th width>
              已核销
              <br />件数
            </th>
            <th width>
              未核销
              <br />件数
            </th>
            <th width>
              已发起
              <br />付款金额(元)
            </th>
            <th width>
              已核销未发起
              <br />付款金额(元)
            </th>
            <th width>
              平台已确认
              <br />收款金额(元)
            </th>
            <th width>
              平台未确认
              <br />收款金额(元)
            </th>
            <th width>⽋款(元)</th>
          </tr>
          <tr v-for="(item, index) in lDetail.orderPurchaseList" :key="index">
            <td>{{item.order_number}}</td>
            <td>{{item.order_purchase_quantity}}</td>
            <td>{{item.item_order_price | tablePrice}}</td>
            <td>{{item.sumOrderEstablishQuantity}}</td>
            <td>{{item.notOutBillsumOrderEstablishQuantity}}</td>
            <td></td>
            <td></td>
            <td>{{item.amountConfirmedByPlatform}}</td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
    </div>

    <el-dialog
      title="确认退货数量"
      :visible.sync="confirmReturnGoodsPop"
      width="500px"
      :close-on-click-modal="false"
      class="cg-dialog"
    >
      <div class="cg-dialog-body">
        <div class="line">
          清算订单号：
          <span class="black">{{lDetail.order_number}}</span>
        </div>
        <div class="line pdb-20">
          商品款号：
          <span class="black">{{lDetail.item_style_number}}</span>
        </div>
        <div class="line">
          累计已核销数量：
          <span class="black">{{liquidateDataInfo_data.sumOrderEstablish}}件</span>
        </div>
        <div class="line pdb-20">
          未核销数量总数：
          <span
            class="black"
          >{{liquidateDataInfo_data.sumOrderQuantity - liquidateDataInfo_data.sumOrderEstablish}}件</span>
        </div>
        <div class="line">
          退货数量：
          <span class="red">{{liquidateDataInfo_data.orderRefundQuantity}}件</span>
        </div>
        <div class="line">
          自动核销数量：
          <span class="red">{{liquidateDataInfo_data.autoEstablish}}件</span>
        </div>
      </div>
      <div class="cg-dialog-footer">
        <button class="cg-btn" @click="rejectRefundQuantity">拒绝</button>
        <button class="cg-btn red mgl-16" @click="confirmRefundQuantity">确认</button>
      </div>
    </el-dialog>

    <!-- 确认付款凭证 -->
    <el-dialog
      title="确认付款凭证"
      :visible.sync="supplierSurePayPop"
      width="500px"
      :close-on-click-modal="false"
      class="cg-dialog"
    >
      <div class="cg-dialog-body">
        <div class="line">
          清算订单号：
          <span class="black">{{lDetail.order_number}}</span>
        </div>
        <div class="line pdb-20">
          商品款号：
          <span class="black">{{lDetail.item_style_number}}</span>
        </div>
        <div class="line">
          本期账单总金额：
          <span class="black">{{platformPopShowData.sumAmount}}元</span>
        </div>
        <div class="line">
          本期账单累计已支付：
          <span class="black">{{platformPopShowData.hadPaidAmount}}元</span>
        </div>
        <div class="line pdb-20">
          本期需支付金额：
          <span class="red">{{platformPopShowData.restPayAmount}}元</span>
        </div>

        <div class="line">
          本次销售商付款金额：
          <span class="black">{{platformPopShowData.currentPay}}元</span>
        </div>
        <div class="line">
          剩余欠款金额：
          <span class="red">{{platformPopShowData.currentRest}}元</span>
        </div>
      </div>
      <div class="cg-dialog-footer">
        <button class="cg-btn" @click="supplierSurePayPop=false">取消</button>
        <button
          class="cg-btn red mgl-16"
          @click="supplierSurePay"
        >确认收到{{platformPopShowData.currentPay}}元</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  launchLiquidate,
  liquidateInfo,
  confirmRefundQuantity,
  returnGoodInfo,
  confirmLiquidatePayment,
  getBillList
} from "../../../api/supplier";
import { accMul, accDiv, accSub } from "../../../utils/tools";
export default {
  data() {
    return {
      lDetail: {
        dealerName: "",
        dealer_user_id: "",
        itemFeeSplitting: "",
        item_id: "",
        item_name: "",
        item_order_price: "",
        item_style_number: "",
        orderPurchaseList: [],
        order_id: "",
        order_number: "",
        order_state: "",
        productMainImageFile: "",
        supplierName: "",
        supplier_user_id: ""
      },

      // 清算相关数据
      liquidateDataInfo: "",
      liquidateDataInfo_data: "",

      // 确认退货数量弹框
      confirmReturnGoodsPop: false,
      returnGoodsList: [],
      currentReturnGoods: {},

      // 确认销售商付款
      supplierSurePayPop: false,
      billList_final_list: [],
      billList_final: {},
      billPeriodPayDetail: {},
      billSinglePayDetail: {},

      // 确认平台结款
      platformUploadPayPop: false,
      platform_billList_final_list: [],
      platform_billList_final: {},
      platformPopShowData: {},
    };
  },
  created() {
    this.getLiquidationDetail();
    this.returnGoodInfo();
  },
  methods: {
    // 获取清算详情
    getLiquidationDetail() {
      liquidateInfo({
        liquidateOrderId: this.$route.query.orderId
      })
        .then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            this.lDetail = res.data[0];
            this.lDetail.productMainImageFile = this.lDetail
              .productMainImageFile
              ? process.env.VUE_APP_IMG_PREV + this.lDetail.productMainImageFile
              : "";
            if (this.lDetail.liquidateDataInfo) {
              this.liquidateDataInfo = this.lDetail.liquidateDataInfo;
              this.liquidateDataInfo_data = JSON.parse(
                this.liquidateDataInfo.order_content
              );
            } else {
              this.liquidateDataInfo = "";
              this.liquidateDataInfo_data = "";
            }
            if (this.lDetail.orderPurchaseList) {
              this.lDetail.orderPurchaseList = this.lDetail.orderPurchaseList.map(item => {
                let verifyNum = item.getEstablishOrderInfoList.reduce((sum, v) => sum + v.order_establish_quantity, 0)
                let notVerifyNum = item.order_purchase_quantity - verifyNum
                return {
                  ...item,
                  verifyNum,     // 已核销数
                  notVerifyNum,  // 未核销数
                  // payAmount: '',     // 已支付
                  // notPayAmount: '',  // 已核销未支付
                  // confirmPay: '',    // 平台已确认
                  // notConfirmPay: '', // 平台未确认
                  // restPay: ''        // 欠款
                }
                
              })
            }
            

            this.lDetail.supplier_rate = this.lDetail.itemFeeSplitting
                ? accMul(this.lDetail.itemFeeSplitting.split(",")[1], 100)
                : "";
            this.lDetail.dealer_rate = this.lDetail.itemFeeSplitting
                ? accMul(this.lDetail.itemFeeSplitting.split(",")[0], 100)
                : "";

            this.getBillList(3);
            this.getBillList(4);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 发起清算
    startLiquidation() {
      this.$confirm("您确定发起清算吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.launchLiquidate();
      });
    },

    // 发起清算 api
    launchLiquidate() {
      launchLiquidate({
        liquidateOrderId: this.$route.query.orderId,
        orderState: "2"
      })
        .then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            this.$message.success(res.errorMsg || "操作成功");
            this.getLiquidationDetail();
          } else {
            this.$message.error(res.errorMsg || "操作是失败");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取退货数量信息
    returnGoodInfo() {
      returnGoodInfo({
        liquidateOrderId: this.$route.query.orderId
      })
        .then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            this.returnGoodsList = res.data;
            this.currentReturnGoods = res.data[0];
          } else {
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取账单信息  1 - 销售商  2 - 平台  3 - 清算账单
    getBillList(billType) {
      getBillList({
        billType: billType,
        orderPurchaseNumber: "",
        liquidateOrderId: this.lDetail.order_id
      })
        .then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            if (billType == 3) {
              this.billList_final_list = res.data.map(element => {
                let order_content = JSON.parse(
                  element.liquidateDataInfo.order_content
                );
                return {
                  ...element,
                  order_arrears_amount: (+element.order_arrears_amount).toFixed(
                    2
                  ),
                  order_bill_amount: (+element.order_bill_amount).toFixed(2),
                  dealerSumPay: (
                    element.order_arrears_amount + element.order_bill_amount
                  ).toFixed(2),
                  autoEstablish: order_content.autoEstablish,
                  sumOrderQuantity: order_content.sumOrderQuantity,
                  sumOrderEstablish: order_content.sumOrderEstablish,
                  orderRefundQuantity: order_content.orderRefundQuantity,
                  order_pay_amount: (+element.order_pay_amount).toFixed(2),
                  chargeBalance: element.chargeBalance
                    ? (+element.chargeBalance > 0
                        ? +element.chargeBalance
                        : 0
                      ).toFixed(2)
                    : (
                        element.order_arrears_amount + element.order_bill_amount
                      ).toFixed(2),
                  liquidateOrderPaymentList: element.liquidateOrderPaymentList
                    ? element.liquidateOrderPaymentList.map(item => {
                        return {
                          ...item,
                          imageFiles: item.image_file
                            ? item.image_file
                                .split(",")
                                .map(ele => (ele ? process.env.VUE_APP_IMG_PREV + ele : ""))
                            : [],
                          restPay: (element.chargeBalance -
                            item.order_payment_amount >
                          0
                            ? element.chargeBalance - item.order_payment_amount
                            : 0
                          ).toFixed(2)
                        };
                      })
                    : []
                };
              });
              this.billList_final = this.billList_final_list[0] || {};
            }

            if (billType == 4) {
              this.platform_billList_final_list = res.data.map(element => {
                // let order_content = JSON.parse(element.liquidateDataInfo.order_content)
                return {
                  ...element,
                  order_arrears_amount: (+element.order_arrears_amount).toFixed(
                    2
                  ),
                  order_bill_amount: (+element.order_bill_amount).toFixed(2),
                  dealerSumPay: (
                    element.order_arrears_amount + element.order_bill_amount
                  ).toFixed(2),
                  // autoEstablish: order_content.autoEstablish,
                  // sumOrderQuantity: order_content.sumOrderQuantity,
                  // sumOrderEstablish: order_content.sumOrderEstablish,
                  // orderRefundQuantity: order_content.orderRefundQuantity,
                  order_pay_amount: (+element.order_pay_amount).toFixed(2),
                  sum_pay_amonut: (element.order_arrears_amount + element.order_bill_amount).toFixed(2),
                  chargeBalance: element.chargeBalance
                    ? (+element.chargeBalance > 0
                        ? +element.chargeBalance
                        : 0
                      ).toFixed(2)
                    : (
                        element.order_arrears_amount + element.order_bill_amount
                      ).toFixed(2),
                  liquidateOrderPaymentList: element.liquidateOrderPaymentList
                    ? element.liquidateOrderPaymentList.map(item => {
                        return {
                          ...item,
                          imageFiles: item.image_file
                            ? item.image_file
                                .split(",")
                                .map(ele => (ele ? process.env.VUE_APP_IMG_PREV + ele : ""))
                            : [],
                          restPay: (element.chargeBalance -
                            item.order_payment_amount >
                          0
                            ? element.chargeBalance - item.order_payment_amount
                            : 0
                          ).toFixed(2)
                        };
                      })
                    : []
                };
              });
              this.platform_billList_final =
                this.platform_billList_final_list[0] || {};
            }
          } else {
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    //确认退货数量
    confirmRefundQuantity() {
      confirmRefundQuantity({
        liquidateOrderId: this.$route.query.orderId,
        orderState: "3"
      })
        .then(res => {
          this.confirmReturnGoodsPop = false;
          console.log(res);
          if (res.errorCode == 200) {
            this.$message.success(res.errorMsg || "操作成功");
            this.getLiquidationDetail();
            this.returnGoodInfo();
          } else {
            this.$message.error(res.errorMsg || "操作是失败");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    //确认退货数量
    rejectRefundQuantity() {
      confirmRefundQuantity({
        liquidateOrderId: this.$route.query.orderId,
        orderState: "4"
      })
        .then(res => {
          this.confirmReturnGoodsPop = false;
          console.log(res);
          if (res.errorCode == 200) {
            this.$message.success(res.errorMsg || "操作成功");
            this.getLiquidationDetail();
            this.returnGoodInfo();
          } else {
            this.$message.error(res.errorMsg || "操作是失败");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取当前账单
    getBillPayDetail(pay_ele) {
        console.log(pay_ele)
      this.platformPopShowData = {
        sumAmount: this.platform_billList_final.sum_pay_amonut,
        hadPaidAmount: this.platform_billList_final.order_pay_amount,
        restPayAmount: (this.platform_billList_final.sum_pay_amonut - this.platform_billList_final.order_pay_amount),
        currentPay: pay_ele.order_payment_amount,
        currentRest: (this.platform_billList_final.sum_pay_amonut - this.platform_billList_final.order_pay_amount-pay_ele.order_payment_amount),
        order_number: pay_ele.order_number
      }
      console.log(this.platformPopShowData)
      this.supplierSurePayPop = true;
    },
    // 确认平台结款
    supplierSurePay() {
      confirmLiquidatePayment({
        orderLiquidatePaymentNumber: this.platformPopShowData.order_number,
        liquidatePaymentState: "y",
        liquidateOrderId: this.lDetail.order_id,
        liquidateBillOrderId: this.platform_billList_final.order_id,
      })
        .then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            this.supplierSurePayPop = false;
            this.$message.success("操作成功");
            this.getBillList(3);
            this.getBillList(4);
            if(this.platformPopShowData.currentRest <= 0) {
                this.getLiquidationDetail()
            }
          } else {
            this.$message.error(res.errorMsg || "操作失败");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取订单数据
    getReserverOrderInfo() {
      getReserverOrderInfo({
        orderPurchaseNumber: this.$route.query.orderPurchaseNumber
      })
        .then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            let detail = res.data[0];
            this.orderState = detail.order_state;
            this.orderDetail = detail;
            this.imgUrl =
              process.env.VUE_APP_IMG_PREV + detail.productMainImageFile;
            this.srcList.push(this.imgUrl);

            this.orderDetail.supplier_rate = this.orderDetail.itemFeeSplitting
              ? accMul(this.orderDetail.itemFeeSplitting.split(",")[1], 100)
              : "";
            this.orderDetail.dealer_rate = this.orderDetail.itemFeeSplitting
              ? accMul(this.orderDetail.itemFeeSplitting.split(",")[0], 100)
              : "";

            let B_order_state = "";
            if (detail.order_state == 2 || detail.order_state == 3) {
              if (detail.sumEstablishQuantity == 0) {
                B_order_state = "从未核销";
              } else if (
                detail.sumEstablishQuantity < detail.order_purchase_quantity
              ) {
                B_order_state = "部分核销";
              } else if (
                detail.sumEstablishQuantity == detail.order_purchase_quantity
              ) {
                B_order_state = "全部核销";
              }
            }
            this.orderTakedStateText = B_order_state;
            try {
              let group = JSON.parse(detail.order_content);
              let arr = group.group;
              this.orderSizeColorArr = arr || [];
              console.log(this.orderSizeColorArr);
            } catch (error) {
              console.log(error);
              this.orderSizeColorArr = [];
            }

            if (
              detail.reserverOrderInfoList &&
              detail.reserverOrderInfoList.length > 0
            ) {
              this.historyLockOrderList = detail.reserverOrderInfoList.map(
                item => {
                  let group = [];
                  try {
                    let order_content = JSON.parse(item.order_content);
                    group = order_content.group;
                  } catch (error) {
                    console.log(error);
                  }
                  return {
                    ...item,
                    group
                  };
                }
              );
            }
            console.log(this.historyLockOrderList);

            this.getOrderEstablish(detail.order_id);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取核销数据
    getOrderEstablish(orderId) {
      getOrderEstablish({
        orderId
      })
        .then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            let unitPrice, supplierRate, sumMoney;
            unitPrice = this.orderDetail.item_order_price;
            supplierRate = this.orderDetail.itemFeeSplitting
              ? this.orderDetail.itemFeeSplitting.split(",")[1]
              : "";

            this.checkSaleHistory = res.data.map(item => {
              let quantityObj = JSON.parse(item.order_content);
              try {
                let s1 = accMul(unitPrice, quantityObj.orderEstablishQuantity);
                let s2 = accMul(s1, supplierRate);
                sumMoney = s2.toFixed(2);
              } catch (error) {
                sumMoney = "--";
              }
              return {
                ...item,
                orderEstablishQuantity: quantityObj.orderEstablishQuantity,
                beforeOrderQuantity: quantityObj.beforeOrderQuantity,
                restQuantity:
                  quantityObj.beforeOrderQuantity -
                  quantityObj.orderEstablishQuantity,
                unitPrice: unitPrice,
                supplierRate: accMul(Number(supplierRate), 100),
                sumMoney: sumMoney
              };
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  min-width: 1030px;
}
.test-btns {
  position: absolute;
  right: 10px;
  top: 10px;
}
.page-section {
  padding: 24px 24px;
  background: #fff;
  margin-bottom: 16px;
}
.header-handle-box {
  min-width: 980px;
  box-sizing: border-box;
  margin-top: 24px;
  border: 1px solid #e6e6e6;
  background: #fafafa;
  padding: 40px 80px;
  .state {
    font-size: 20px;
    color: #333;
    font-weight: 500;
    &.red {
      color: #f81d22;
    }
  }
  .status {
    color: #F81D22;
    margin-left: 10px;
    font-size: 16px;
   }
  .btns {
    margin-top: 40px;
    .cg-btn {
      margin-right: 20px;
    }
  }
  .tip {
    margin-top: 14px;
    height: 20px;
    font-size: 14px;
    color: rgba(51, 51, 51, 0.6);
    line-height: 20px;
  }
  .tip-small {
    margin-left: 8px;
    height: 20px;
    font-size: 14px;
    color: rgba(51, 51, 51, 0.6);
    font-size: normal;
    line-height: 20px;
  }
}
.basic-info {
  &.mgt-24 {
    margin-top: 24px;
  }
  &.mgt-40 {
    margin-top: 40px;
  }
  .line {
    padding-bottom: 16px;
    font-size: 14px;
    line-height: 22px;
    .lab {
      color: rgba(0, 0, 0, 0.85);
    }
    .val {
      color: rgba(0, 0, 0, 0.65);
    }
    &.blue .lab,
    &.blue .val {
      color: #1890ff;
    }
    .green {
      color: #52c41a;
    }
    .text-btn {
      margin-left: 16px;
      background: transparent;
      border: none;
      font-size: 14px;
      color: #1890ff;
      outline: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.basic-wrap {
  margin-top: 24px;
  padding: 24px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  .img-wrap {
    float: left;
    width: 100px;
    height: 100px;
    border: 1px solid #f0f0f0;
    .img {
      width: 100px;
      height: 100px;
    }
  }
  .basic-info {
    padding-left: 136px;
    .line {
      padding-bottom: 16px;
      font-size: 14px;
      line-height: 22px;
      .lab {
        color: rgba(0, 0, 0, 0.85);
      }
      .val {
        color: rgba(0, 0, 0, 0.65);
        &.tit {
          display: inline-block;
          vertical-align: top;
          width: 720px;
        }
      }
    }
  }
}

.take-order-table {
  &.scroll {
    height: 50vh;
    overflow-y: auto;
    overflow-x: visible;
  }
  .table {
    border: 1px solid #e6e6e6;
    width: 100%;
    min-width: 980px;
    border-spacing: 0;
    border-collapse: collapse;
    font-size: 14px;
    tr {
      height: 50px;
    }
    tr.th {
      background: #fafafa;
    }
    tr th {
      color: rgba(0, 0, 0, 0.85);
      font-weight: normal;
    }
    td {
      border: 1px solid #e6e6e6;
      text-align: center;
      color: rgba(0, 0, 0, 0.85);
    }
    &.min-400 {
      min-width: 400px;
    }
  }
  &.mgt-24 {
    margin-top: 24px;
  }
  &.clearing {
    margin-top: 24px;
  }
  &.clearing tr th {
    border: 1px solid #e6e6e6;
  }
  &.clearing tr th:last-child,
  &.clearing tr td:last-child {
    color: #f81d22;
  }
}

.gap-line {
  margin: 40px 0;
  height: 1px;
  background: #e6e6e6;
}


.time-line-title {
  margin-top: 16px;
  .time-line-title-h4 {
    font-size: 13px;
    font-weight: bold;
    line-height: 2;
  }
  .time-line-title-sub {
    margin-top: 16px;
    font-size: 13px;
  }
}
.time-line {
  margin-top: 24px;
  list-style: none;
  .item {
    position: relative;
    .item-tail {
      position: absolute;
      top: 10px;
      left: 4px;
      width: 2px;
      height: 100%;
      background: #f7f7f7;
    }
    .item-node {
      position: absolute;
      top: 10px;
      left: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #d9d9d9;
    }
    &:first-child .item-node {
      background: #2a2e3f;
    }
    &:last-child .item-tail {
      width: 0;
    }
    .item-content {
      padding-left: 32px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
      padding-bottom: 16px;
    }
    .item-tit {
      padding-bottom: 8px;
    }
    .item-box {
      background: rgba(0, 0, 0, 0.02);
      border-radius: 2px;
      padding: 24px;
      .img {
        width: 100px;
        height: 100px;
        border: 1px solid #eee;
        vertical-align: top;
        margin-right: 4px;
      }
      .pay-info {
        display: inline-block;
        width: 400px;
        margin-left: 10px;
        font-size: 13px;
      }
      .pdb-12 {
        padding-bottom: 12px;
      }
      .pdb-6 {
        padding-bottom: 6px;
      }
      .grey {
        color: rgba(0, 0, 0, 0.45);
      }
      .green {
        color: #52c41a;
      }
      .blue {
        color: #1890ff;
      }
    }
    .title {
        display: inline-block;
        width: 450px;
    }
    .time {font-size: 13px; color: #000; margin-right: 6px;}
    .img {
        width: 100px; height: 100px; border: 1px solid #eee;
        vertical-align: top;
        margin-right: 6px;
    }
  }
  .sub-time-line {
    list-style: none;
    .sub-item {
      position: relative;
      padding-left: 24px;
      .title {
        display: inline-block;
        width: 450px;
      }
      &::before {
        content: " ";
        position: absolute;
        top: 15px;
        left: 3px;
        width: 1px;
        height: calc(100% - 12px);
        background: #d8d8d8;
      }
      &::after {
        content: " ";
        position: absolute;
        top: 6px;
        left: 0;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #fff;
        border: 1px solid #d8d8d8;
        box-sizing: border-box;
      }
      &:first-child::after {
        background: #ff9c6e;
        border: 1px solid #ff9c6e;
      }
      &:last-child::before {
        width: 0;
      }
    }
  }
}

.address-wrap {
  padding-top: 16px;
}
.address-label {
  font-size: 14px;
  font-weight: 500;
  color: #666;
  line-height: 30px;
}
.address-content {
  padding: 6px 0px;
  color: #333;
  font-size: 13px;
  .line {
    margin-bottom: 6px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .gap {
    margin-left: 30px;
  }
}
</style>